import {RouterProvider} from "react-router-dom";
import {router} from "../../routes";
import { AuthProvider } from "../../context/AuthContext";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <RouterProvider router={router} />
            </AuthProvider>
        </div>
      );
}

export default App;
